import type { TOC } from '@ember/component/template-only';

import MetricLibraryExtraActionsComponent from 'webapp/components/metric-library/extra-actions';
import SourceTypeInfoTabsHelpArticlesComponent from 'webapp/components/source-type-info-tabs/help-articles';

import type Source from 'webapp/models-custom/source';
import type SourceType from 'webapp/models-custom/source-type';

export interface Args {
	sourceType: SourceType;
	source?: Source | null;
}
const MetricLibrarySourceTabsHelpArticlesComponent: TOC<Args> = <template>
	<div class="metric-library-source-help_articles">
		<SourceTypeInfoTabsHelpArticlesComponent @model={{@sourceType}} />
		<MetricLibraryExtraActionsComponent @model={{@source}} />
	</div>
</template>;

export default MetricLibrarySourceTabsHelpArticlesComponent;
